import React, { useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import { Route, Switch, useRouteMatch, NavLink } from "react-router-dom";
import { useParams } from "react-router-dom";
import { GET_DETAIL_STUDENT } from "../../../Templates/components/APIs";
import LoadingBtn from "../../Widgets/LoadingBtn";
import { AlertNotif } from "../../../Library/AlertNotif";
import { Error404 } from "../../../Library/LoaderPage";
import { CAcadStd } from "./Acad";
import { CBioStd } from "./Biodata";
import { CActivityStd } from "./ActivityHist";
import { DetailActivity } from "./ActivityHist/DetailActivity";
import { CCPStd } from "./CoursePlan";
import { StdHeader } from "../../Student/Profiles/components";
import TableCurriculums from "../../Student/Curriculums/TableCurriculums";
import { WarningStudyPeriode } from "./components";
import { RSAencryptData } from "../../StudentNewComming/Documents/RSAEnc";
import { DOWNLOAD_REQUEST_DOC, GET_DOC_LIST } from "../../StudentNewComming/APIS";

const AuthToken = localStorage.getItem("AuthToken");
const AuthDecode = AuthToken ? jwt_decode(AuthToken) : [];

export function DetailStudent() {
  const { stdid } = useParams();
  const { path } = useRouteMatch();

  const objNavStd = [
    {
      id: 1,
      name: "Academic Information",
      link: "/counseling/student/" + stdid + "/academic",
      icon: "flaticon2-open-text-book",
    },
    {
      id: 2,
      name: "Biodata",
      link: "/counseling/student/" + stdid + "/biodata",
      icon: "flaticon-profile",
    },
    {
      id: 3,
      name: "Transcript",
      link: "/counseling/student/" + stdid + "/transcript",
      icon: "fas fa-book-reader",
    },
    {
      id: 4,
      name: "Curriculum",
      link: "/counseling/student/" + stdid + "/curriculum",
      icon: "flaticon2-open-text-book",
    },
    {
      id: 5,
      name: "Activity History",
      link: "/counseling/student/" + stdid + "/activity",
      icon: "flaticon2-checking",
    },
  ];

  const doc_req_name = `pas_foto_file_${stdid}`;
  const status_file = "strg.file.status.uploaded";
  const doc_type = "strg.doc.type.pasfoto";

  const [docList, setDocList] = useState([]);
  const [student, setStudent] = useState({
    loading: false,
    data: [],
    message: "",
  });
  const [registered_id, setRegistered_id] = useState("");

  const ReloadStudent = async () => {
    try {
      setStudent({ loading: true, data: [], message: "" });
      const results = await GET_DETAIL_STUDENT({ studentid: stdid });
      if (results.data && Object.values(results.data).length > 0) {
        setRegistered_id(results.data?.registered_id || "");
      } else {
        setRegistered_id("");
      }
      setStudent(results);
    } catch (error) {
      setStudent({ loading: false, data: [], message: error?.message });
      setRegistered_id("");
    }
  };

  useEffect(() => {
    ReloadStudent();
  }, [stdid]);

  const OWNER_DOC = async (registered_id) => {
    try {
      setDocList([]);
      const param = { owner: registered_id };
      const objData = JSON.stringify(param);
      const rsaEnc = RSAencryptData(objData);
      const formData = new FormData();
      formData.append("data", rsaEnc);
      const results = await GET_DOC_LIST(formData);
      if (results.result === "success") {
        if (results.data && Object.values(results.data).length > 0) {
          const r_data = results.data?.data || [];
          if (Object.values(r_data).length > 0) {
            const get_active_doc = r_data.find(
              (item) => item.status === status_file && item.doc_type === doc_type
            );
            setDocList(get_active_doc);
            localStorage.setItem(doc_req_name, JSON.stringify(get_active_doc));
          } else {
            setDocList([]);
          }
        } else {
          setDocList([]);
        }
      } else {
        setDocList([]);
      }
    } catch (error) {
      setDocList([]);
    }
  };

  useEffect(() => {
    const loadData2 = async () => {
      const storedData = localStorage.getItem(doc_req_name);
      if (storedData) {
        try {
          const data = JSON.parse(storedData);
          setDocList(data);
        } catch (error) {
          console.error("Error parsing stored data:", error);
          await OWNER_DOC(registered_id);
        }
      } else {
        await OWNER_DOC(registered_id);
      }
    };

    if (registered_id) {
      loadData2();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
  }, [registered_id, student.data])



  try {
    return (
      <div className="detail-std">
        {student.loading ? (
          <LoadingBtn />
        ) : student.message ? (
          <AlertNotif message={student.message} color="info" />
        ) : student.data && Object.values(student.data).length > 0 ? (
          <div className="">
            <StdHeader student={student.data}>
              <div className="separator"></div>
              <div className="">
                <ul className="nav nav-light-success nav-bold nav-pills">
                  {objNavStd.map((m, index) => (
                    <li className="nav-item" key={index}>
                      <NavLink to={m.link} className={"nav-link"}>
                        <span className="nav-icon">
                          <i className={m.icon}></i>
                        </span>
                        <span className="nav-text">{m.name}</span>
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            </StdHeader>

            <WarningStudyPeriode student={student.data} />

            <Switch>
              <Route
                path={`${path}/academic`}
                render={(props) => (
                  <CAcadStd {...props} studentData={student.data} />
                )}
              />
              <Route
                path={`${path}/biodata`}
                render={(props) => (
                  <CBioStd {...props} studentData={student.data} />
                )}
              />
              <Route
                path={`${path}/transcript`}
                render={(props) => (
                  <CCPStd {...props} studentData={student.data} />
                )}
              />
              <Route
                path={`${path}/curriculum`}
                render={() => (
                  <TableCurriculums
                    param={{
                      clu_id: student.data?.clu?.id || 0,
                      clu_spec_id: student.data?.clu_spec?.id || 0,
                      curr_id: student.data?.curr?.id || 0,
                      studentid: student.data?.studentid || "",
                    }}
                  />
                )}
              />
              <Route
                path={`${path}/activity`}
                render={(props) => (
                  <CActivityStd {...props} studentData={student.data} />
                )}
                exact
              />
              <Route
                path={`${path}/activity/:id`}
                render={(props) => (
                  <DetailActivity {...props} studentData={student.data} />
                )}
              />
            </Switch>
          </div>
        ) : (
          <Error404 />
        )}
      </div>
    );
  } catch (error) {
    return <AlertNotif message={error?.message} color="danger" />
  }
}
